import { RefreshCcw } from 'lucide-react';
import { Button } from '../components/ui/button';

export const DetailsPageLoader = () => (
  <div className="flex items-center justify-center h-full">
    <div className="flex flex-col items-center space-y-4">
      <RefreshCcw className="h-8 w-8 animate-spin text-muted-foreground" />
      <p className="text-muted-foreground">Loading...</p>
    </div>
  </div>
);

export const DetailsPageError = ({ onRetry }: { onRetry?: () => void }) => (
  <div className="flex items-center justify-center h-full">
    <div className="flex flex-col items-center space-y-4">
      <p className="text-destructive">Error loading content</p>
      <Button onClick={onRetry || (() => window.location.reload())} variant="outline">
        Try again
      </Button>
    </div>
  </div>
); 